<template>
  <div class="taskContainer" data-cy="mypage_single_task">
    <Task v-bind="parsedTask" @click="$emit('click', $event)" />
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Task from '@/components/mypage/Task.vue';

export default Vue.extend({
  name: 'TaskContainer',
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  components: {
    Task,
  },
  computed: {
    parsedTask() {
      return {
        iconName: this.iconName || '',
        header: this.header,
        date: moment.utc(this.task.modified).local().format('DD.MM.YYYY'),
        status: this.status || '',
        buttons:
          this.task.actions && Array.isArray(this.task.actions)
            ? this.task.actions.map(action => {
                return {
                  ...this.buttonDisplay(action.type),
                  action: action.type,
                  externalUrl: action.externalUrl,
                  params: {
                    taskId: this.task.id,
                    landlordId: this.task.landlordId,
                    ...(action.params && typeof action.params === 'object' ? action.params : {}), // add all custom params
                  },
                };
              })
            : undefined,
      };
    },
    iconName() {
      return {
        contract: 'budicon-document-page',
        top: 'budicon-ui-compose',
        ir: 'budicon-ui-compose',
        letting: 'budicon-announcement',
        lease_termination: 'budicon-file-block',
        deposit_leabank: 'budicon-savings',
        deposit_instabank: 'budicon-savings',
        landlord_provide_electricity_number: 'budicon-electric-cord',
      }[this.task.type];
    },
    header() {
      if (this.task.type === 'contract' && this.task.tenant && this.task.tenant.fullName) {
        return `Leiekontrakt med ${this.task.tenant.fullName}`;
      }

      if (this.task.type === 'contract') {
        return `Påbegynt leiekontrakt for ${this.task.rentalObject.name}`;
      }

      if (this.task.type === 'letting') {
        return `Annonse for ${this.task.rentalObject.name}`;
      }

      if (this.task.type === 'top' || this.task.type === 'ir-takeover') {
        return (
          `Overtakelsesprotokoll for ${this.task.rentalObject.name} med ` +
          `${(this.task.tenant && this.task.tenant.fullName) || 'N/A'}`
        );
      }
      if (this.task.type === 'ir-moveout') {
        return (
          `Utflyttingsprotokoll for ${this.task.rentalObject.name} med ` +
          `${(this.task.tenant && this.task.tenant.fullName) || 'N/A'}`
        );
      }

      if (this.task.type === 'lease_termination') {
        return `Oppsigelse av leieforhold med ${this.task.tenant.fullName}`;
      }

      if (this.task.type === 'deposit_leabank') {
        return `Leabank depositumskonto med ${this.task.tenant.givenName} ${this.task.tenant.familyName}`;
      }

      if (this.task.type === 'deposit_instabank') {
        return `Instabank depositumskonto med ${this.task.tenant.givenName} ${this.task.tenant.familyName}`;
      }

      if (this.task.type === 'landlord_provide_electricity_number') {
        return `Registrer strømmåleren for ${this.task.rentalObject.name}`;
      }

      return this.task.type;
    },
    status() {
      return {
        draft: 'Utkast',
        open: 'Utkast',
        signing_tenant: 'Venter på leietakers signatur',
        signing_landlord: 'Venter på utleiers signatur',
        locked_for_signing: 'Lukket for signering',
        XXX: 'Utkast',
        MISSING_SIGNATURE_FROM_ALL: 'Mangler signatur fra begge parter',
        MISSING_SIGNATURE_FROM_TENANT: 'Mangler signatur fra leietaker',
        MISSING_SIGNATURE_FROM_LANDLORD: 'Mangler signatur fra utleier',
      }[this.task.status];
    },
  },
  methods: {
    buttonDisplay(actionType) {
      return {
        top_sign: {
          text: 'Signer',
          type: 'primary',
        },
        top_edit: {
          text: 'Rediger',
          type: 'primary',
        },
        top_delete: {
          text: 'Slett',
          type: 'secondary',
        },
        ir_edit: {
          text: 'Rediger',
          type: 'primary',
        },
        ir_delete: {
          text: 'Slett',
          type: 'secondary',
        },
        contract_edit: {
          text: 'Rediger',
          type: 'primary',
        },
        contract_delete: {
          text: 'Slett',
          type: 'secondary',
        },
        contract_preview: {
          text: 'Forhåndsvisning',
          type: 'secondary',
        },
        contract_cancel_signing: {
          text: 'Avbryt signering',
          type: 'secondary',
        },
        contract_landlord_sign: {
          text: 'Signer',
          type: 'primary',
        },
        lease_termination_edit: {
          text: 'Rediger',
          type: 'primary',
        },
        lease_termination_delete: {
          text: 'Slett',
          type: 'secondary',
        },
        letting_edit: {
          text: 'Rediger',
          type: 'primary',
        },
        letting_delete: {
          text: 'Slett',
          type: 'secondary',
        },
        deposit_instabank_sign: {
          text: 'Signer nå',
          type: 'primary',
        },
        landlord_provide_electricity_number: {
          text: 'Registrer',
          type: 'primary',
        },
        deposit_account_termination: {
          text: 'Avslutt',
          type: 'secondary',
        },
        ignore_task: {
          text: 'Skjul',
          type: 'secondary',
        },
      }[actionType];
    },
  },
});
</script>
